import { render, staticRenderFns } from "./QuizDetail.vue?vue&type=template&id=51f899f6&"
import script from "./QuizDetail.vue?vue&type=script&lang=js&"
export * from "./QuizDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports